import { ThemeOptions } from '@mui/material';
import styleVariables from '../styles/styleVariables';

const themeDefaultConfig = {
	breakpoints: {
		values: {
			xs: 0,
			sm: 600,
			md: 900,
			lg: 1200,
			xl: 1536,
			mobile: 0,
			tablet: 640,
			laptop: 1024,
			desktop: 1200,
		},
	},
	palette: {
		mode: 'light',
		background: {
			default: '#f2f2f2',
			paper: '#FFF', // Couleur de fond Paper par défaut
		},
		text: {
			primary: '#1A2B48',
			secondary: '#2ABDBB',
			disabled: styleVariables.greyColor,
		},
		primary: {
			main: '#1A2B48',
			dark: '#1B2C48',
			disabled: styleVariables.greyColor,
		},
		secondary: {
			main: styleVariables.secondaryColor,
			dark: '#2ABDBB', // Couleur de fond des Paper
			contrastText: '#FFF',
			disabled: styleVariables.greyColor,
		},

		info: {
			main: styleVariables.secondaryColor,
		},
	},
	typography: {
		fontFamily: ['Poppins', 'Cambo'].join(','),
		h1: {
			fontFamily: 'Poppins',
			fontStyle: 'normal',
			fontWeight: 600,
			fontSize: '2.19rem',
			lineHeight: '52px',
			marginTop: '0px',
			color: '#1A2B48',
		},
		h2: {
			fontFamily: 'Poppins',
			fontStyle: 'normal',
			fontWeight: 600,
			fontSize: '1.4rem',
			margin: '0px',

			lineHeight: '1.5',
			color: '#1A2B48',
		},
		h3: {
			fontFamily: 'Poppins',
			fontStyle: 'normal',
			fontWeight: 600,
			fontSize: '1.125rem',
			marginBottom: '20px',
			lineHeight: '1.5',
			marginTop: '0px',
			color: '#1A2B48',
		},
	},

	components: {
		MuiAlert: {
			styleOverrides: {
				standardError: {
					backgroundColor: '#ff2626',
					color: 'white',
					'& .MuiAlert-icon': {
						color: 'white',
					},
				},
			},
		},

		MuiAutocomplete: {
			styleOverrides: {
				root: {
					'& label': {
						fontSize: '0.9375rem',
					},
					'& .MuiInputLabel-root': {
						padding: '0px 0px',
						top: '6px',
						backgroundColor: 'transparent',
						'&.MuiInputLabel-shrink': {
							top: '-10px',
							left: '-15px',
							backgroundColor: 'transparent',
						},
					},
				},
				clearIndicator: {
					color: styleVariables.primaryColor,
				},
				popupIndicator: {
					color: styleVariables.primaryColor,
				},
				input: {
					fontSize: 13,
					height: 28,
				},
				listbox: {
					fontSize: 13,
				},
			},
		},
		MuiInput: {
			styleOverrides: {
				root: {
					border: '1px solid #1A2B48',
				},
			},
		},
		MuiInputLabel: {
			styleOverrides: {
				outlined: {
					'&.MuiInputLabel-shrink': {
						top: '-5px',
						left: '-10px',
						color: '#9C9C9C',
					},
				},
			},
		},
		MuiInputBase: {
			styleOverrides: {
				root: {
					backgroundColor: 'white',
					padding: '0px',
					border: '1px solid #CCC',
					'& fieldset': {
						border: 'none',
						color: '#1A2B48',
						'&.MuiOutlinedInput-notchedOutline': {
							display: 'none',
						},
					},
					color: '#1A2B48',
					'& .MuiOutlinedInput-input': {
						padding: '13px',
					},
				},
				input: {
					fontSize: '0.95rem',
				},
				sizeSmall: {
					fontSize: '0.8125rem',
				},
			},
		},
		MuiButton: {
			styleOverrides: {
				root: {
					borderRadius: '6px',
					border: 'none',
					minWidth: '60px',
					padding: '13px',
					textTransform: 'none',
					lineHeight: '1.5',
					fontWeight: '500',
					fontSize: '1rem',
					fontFamily: 'Poppins',
					fontStyle: 'normal',
					boxShadow: 'none',
				},
				outlined: {
					fontSize: '0.9rem',
					border: '1px solid',
				},
				sizeSmall: {
					padding: '11px 20px',
				},
				containedSecondary: {
					'&.Mui-disabled': {
						color: 'inherit',
						backgroundColor: styleVariables.secondaryColor,
						opacity: 0.5,
					},
				},
			},
		},
		MuiTab: {
			styleOverrides: {
				root: {
					fontWeight: '500',
					fontFamily: 'Poppins',
					fontSize: '1.125rem',
					lineHeight: '1.5',
					textTransform: 'none',
					color: styleVariables.primaryColor,
					minHeight: 'initial',
					paddingLeft: '0px',
					paddingRight: '0px',
					marginLeft: '0px',
					marginRight: '40px',
					'&.Mui-selected': {
						color: '#2ABDBB',
					},
					'&.active': {
						color: '#2ABDBB',
					},
					'&.inactive': {
						color: styleVariables.primaryColor,
					},
				},
			},
		},
		MuiTabs: {
			styleOverrides: {
				indicator: {
					backgroundColor: '#2ABDBB',
				},
			},
		},
		MuiLink: {
			styleOverrides: {
				root: {
					cursor: 'pointer',
				},
			},
		},
		MuiListItemIcon: {
			styleOverrides: {
				root: {
					minWidth: '40px',
					color: '#2ABDBB',
				},
			},
		},
		MuiPaper: {
			styleOverrides: {
				elevation: {
					boxShadow: '0px 12px 24px rgba(0, 0, 0, 0.19);',
				},
				outlined: {
					boxShadow: 'none',
					border: '0px',
				},
				rounded: {
					borderRadius: '10px',
				},
			},
		},
		MuiChip: {
			styleOverrides: {
				root: {},
			},
		},
		MuiDrawer: {
			styleOverrides: {
				root: {
					'*::-webkit-scrollbar': {
						width: '5px',
					},
					'*::-webkit-scrollbar-track': {
						backgroundColor: styleVariables.primaryColor,
					},

					'*::-webkit-scrollbar-thumb': {
						backgroundColor: styleVariables.secondaryColor,
					},
					'& .MuiListItemButton-root': {
						margin: '0px 0px 30px 0px',
						padding: '10px',
						borderRadius: '6px',
						color: 'white',
						'&.Mui-selected': {
							backgroundColor: '#1d4059',
							color: 'white',
							'&:hover': {
								backgroundColor: '#1d4059',
							},
						},
						'&:hover': {
							backgroundColor: '#1A4159',
						},
					},
				},
				paper: {
					background: styleVariables.primaryColor,
					padding: '20px',
				},
			},
		},
		MuiTypography: {
			styleOverrides: {
				root: {
					fontFamily: 'Poppins',
				},
			},
		},
		MuiTextField: {
			styleOverrides: {
				root: {
					'& .MuiInputBase-input': {
						lineHeight: '1.5',
						fontSize: '0.85rem',
					},
					'& label': {
						fontSize: '0.9375rem',
						color: styleVariables.primaryColor,
					},
					'& .MuiInputLabel-root': {
						padding: '0px 4px',
						lineHeight: '1rem',
						borderTopRightRadius: '6px',
						borderTopLeftRadius: '6px',
					},
				},
			},
		},
	},
} as ThemeOptions;

export default themeDefaultConfig;
